import type { LocuslyBlogContent } from './content.schema';

export const defaultContent: LocuslyBlogContent = {
  brand: {
    accent: 'ink',
  },
  pt: {
    siteName: 'Locusly',
    eyebrow: 'Decor que pode comprar',
    title: 'Inspiracao de decoracao que pode recriar.',
    description:
      'Ideias para casamentos e eventos com looks completos, guias de styling e alternativas acessiveis.',
    latestLabel: 'Latest blog posts',
    searchPlaceholder: 'Pesquisar decor, estilos ou posts',
    noResults: 'Nao existem posts que correspondam a esta pesquisa.',
    emptyState: 'Ainda nao existem posts publicados.',
    readLabel: 'Ler post',
    allPostsLabel: 'Todos os posts',
    backLabel: 'Voltar aos posts',
  },
  en: {
    siteName: 'Locusly',
    eyebrow: 'Curated decor. Beautiful moments.',
    title: 'Decor inspiration you can actually shop.',
    description:
      'We help you recreate beautiful wedding and event decor with similar finds, styling tips and budget-friendly alternatives.',
    latestLabel: 'Latest blog posts',
    searchPlaceholder: 'Search decor, styles or posts',
    noResults: 'No posts match this search.',
    emptyState: 'No published posts yet.',
    readLabel: 'Read post',
    allPostsLabel: 'All posts',
    backLabel: 'Back to posts',
  },
  seo: {
    metaTitle: 'Locusly - Wedding decor inspiration you can shop',
    metaDescription:
      'Wedding and event decor inspiration with shoppable finds, styling guides and budget-friendly alternatives.',
  },
};

export default defaultContent;
